<div class="container-fluid ">
  <mat-divider class="mb-4"></mat-divider>
  <div *ngFor="let pasivo of formArray.controls; let i = index">
    <form [formGroup]="formArray.controls[i]" class="row ">
      <mat-form-field appearance="outline" class="col-md-3">
        <mat-label>Institución</mat-label>
        <mat-select formControlName="institucion">
          <mat-option *ngFor="let tipo of getTipoInstitucionKeys()" [value]="tipo">{{ tipoInstitucion[tipo]}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-3">
        <mat-label>Tipo de Crédito</mat-label>
        <mat-select formControlName="tipoCredito">
          <mat-option *ngFor="let tipo of getTipoCreditoKeys()" [value]="tipo">{{ tiposCredito[tipo]}}</mat-option>
        </mat-select>
      </mat-form-field>

      
      <mat-form-field appearance="outline" class="col-md-2">
        <mat-label>Monto</mat-label>
        <input matInput currencyMask type="text" formControlName="monto" placeholder="$">
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="col-md-2">
        <mat-label>Valor de Cuota Mensual</mat-label>
        <input matInput currencyMask type="text" formControlName="valorCuotaMensual" placeholder="$">
      </mat-form-field>
      
      <mat-checkbox formControlName="deudaDirecta" class="col-md-2" style="margin-top: 8px;" matTooltip="Corresponde a una deuda contraída por un tercero de la cual usted es Aval">Deuda Indirecta</mat-checkbox>
      
      <button mat-icon-button color="warn" type="button" (click)="eliminarPasivo(i)" [disabled]="formFirmado" style="margin: auto;">
        <mat-icon>delete</mat-icon>
      </button>
      <mat-divider class="mb-4"></mat-divider>
    </form>
  </div>
  <div class="row">
    <div class="mt-4">
      <button mat-raised-button color="accent" type="button" (click)="agregarPasivo(null)" class="ml1 mr1 fl"><mat-icon >add_circle</mat-icon> Agregar Pasivo</button>
      <button id="pasivosSiguienteBtn" mat-raised-button color="primary" (click)="onSubmit()" class="ml1 mr1 fr">Siguiente</button>
      <button id="pasivosVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
    </div>
  </div>
</div>